import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { bindActionCreators } from 'redux';
import Form from '../../components/forms/InitiativeFormAdding';
import { newInitiative, withRedirect } from '../../CroActions';
import { breadcrumbs } from '../../../../actions/appActions';
import { noop } from 'lodash';

const selector = formValueSelector('initiativeForm');

const mapStateToProps = (state, { params }) => ({
  breadcrumbsItems: [{ label: 'Podněty k prošetření' }, { label: 'Nový podnět' }],
  legalPerson: selector(state, 'legalPerson'),
  attachments: selector(state, 'attachments') || [],
  resultAttachments: selector(state, 'resultAttachments') || [],
  state: null,
  isNew: true,
  rejectText: selector(state, 'rejectText'),
  text: selector(state, 'text'),
});

const mapDispatchToProps = (dispatch, props) => ({
  ...bindActionCreators({ breadcrumbs }, dispatch),
  onSubmit: (...args) => dispatch(withRedirect(newInitiative, `${props.auth.startUrl}/podnety`)(...args)),
  accept: noop,
  reply: noop,
  reject: noop,
  send: noop,
  dispatch,
})

export default connect(mapStateToProps, mapDispatchToProps)(Form);
